export function PageHeader({ eyebrow, title, description, actions }) {
  return (
    <div className="mb-6 flex items-start justify-between gap-4 flex-wrap">
      <div>
        {eyebrow && (
          <div className="text-[10px] font-mono uppercase tracking-[0.2em] text-slate-500 mb-1">{eyebrow}</div>
        )}
        <h1 className="font-heading text-2xl font-bold tracking-tight text-slate-50">{title}</h1>
        {description && <p className="text-sm text-slate-400 mt-1.5 max-w-2xl">{description}</p>}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}

export function StatCard({ label, value, subValue, tone = "default", testid }) {
  const toneClasses = {
    default: "",
    brand: "card-accent",
    critical: "border-red-500/30",
    warning: "border-amber-500/30",
    success: "border-emerald-500/30",
  }[tone];
  return (
    <div className={`card p-5 ${toneClasses}`} data-testid={testid}>
      <div className="stat-label">{label}</div>
      <div className="stat-value">{value}</div>
      {subValue && <div className="mt-2 text-xs text-slate-500 font-mono">{subValue}</div>}
    </div>
  );
}

export function Section({ title, description, actions, children, className = "" }) {
  return (
    <section className={`card mb-6 ${className}`}>
      {(title || actions) && (
        <div className="px-5 py-3 border-b border-slate-800/70 flex items-center justify-between gap-4">
          <div>
            <div className="font-heading text-sm font-semibold text-slate-100">{title}</div>
            {description && <div className="text-xs text-slate-500 mt-0.5">{description}</div>}
          </div>
          {actions && <div className="flex items-center gap-2">{actions}</div>}
        </div>
      )}
      <div>{children}</div>
    </section>
  );
}

export function EmptyState({ icon: Icon, title, description }) {
  return (
    <div className="p-12 text-center">
      {Icon && <Icon size={32} className="mx-auto text-slate-600 mb-3" strokeWidth={1.5} />}
      <div className="text-sm font-medium text-slate-300 mb-1">{title}</div>
      {description && <div className="text-xs text-slate-500">{description}</div>}
    </div>
  );
}

export function RiskBadge({ level }) {
  const cls = { Critical: "badge-critical", High: "badge-high", Medium: "badge-medium", Low: "badge-low" }[level] || "badge-low";
  return <span className={`badge ${cls}`}>{level}</span>;
}

export function StatusBadge({ status }) {
  const map = {
    "Not Assessed": "badge-low", "In Progress": "badge-info",
    "Assessed": "badge-success", "Accepted Risk": "badge-medium",
    "Missing": "badge-critical", "Provided": "badge-info",
    "Validated": "badge-success", "Rejected": "badge-critical",
    "active": "badge-success", "inactive": "badge-low",
    "approved": "badge-success", "pending": "badge-medium", "rejected": "badge-critical",
  };
  return <span className={`badge ${map[status] || "badge-low"}`}>{status}</span>;
}

export function ScoreBadge({ score }) {
  const s = parseFloat(score);
  if (isNaN(s)) return <span className="text-slate-600 font-mono">—</span>;
  const cls = s < 1 ? "badge-critical" : s < 2 ? "badge-high" : s < 3 ? "badge-medium" : s < 4 ? "badge-info" : "badge-success";
  return <span className={`badge ${cls}`}>{s.toFixed(1)}</span>;
}

export function Spinner({ label }) {
  return (
    <div className="flex items-center gap-2 text-slate-400 text-xs">
      <div className="spinner" />
      {label || "Loading..."}
    </div>
  );
}
